import { Link } from "react-router-dom";

const COLS = [
  {
    title: "Product",
    links: [
      { to: "/how-it-works", label: "How It Works" },
      { to: "/features", label: "Features" },
      { to: "/scanner", label: "URL Scanner" },
      { to: "/apk-checker", label: "APK Checker" },
      { to: "/blog", label: "Blog" },
      { to: "/report", label: "Report a Link" },
    ],
  },
  {
    title: "Trust",
    links: [
      { to: "/security", label: "Security" },
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
      { to: "/delete-account", label: "Delete Account" },
    ],
  },
  {
    title: "Company",
    links: [{ to: "/contact", label: "Contact" }],
  },
];

export const WebFooter = () => (
  <footer data-testid="web-footer" className="relative bg-[#030711] border-t border-white/10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-24 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 pb-20">
        <div className="md:col-span-5">
          <Link to="/" data-testid="footer-logo-link" className="flex items-center gap-2.5">
            <img src="/brand-shield.png" alt="LinkExpln logo" className="h-9 w-9 object-contain" />
            <span className="font-heading font-black tracking-tight text-lg text-white">
              LINKEXPLN<span className="text-[#00C5FE] text-[10px] align-super">™</span>
            </span>
          </Link>
          <p className="mt-6 text-zinc-400 text-sm leading-relaxed max-w-sm">
            AI-powered protection against scams, phishing and malicious links.
            Check before you click.
          </p>
          <a
            href="mailto:support@linkexpln.com"
            data-testid="footer-support-email-link"
            className="mt-5 inline-block font-mono-ls text-xs tracking-[0.12em] text-[#00C5FE] hover:text-white underline underline-offset-4 transition-colors duration-200"
          >
            support@linkexpln.com
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.emergent.linkshieldai.lmnv0s"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-get-app-link"
            className="mt-4 block w-fit font-mono-ls text-xs tracking-[0.12em] text-[#00C5FE] hover:text-white underline underline-offset-4 transition-colors duration-200"
          >
            Get the App — Google Play
          </a>
        </div>
        {COLS.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <p className="ls-overline mb-5">{col.title}</p>
            <ul className="space-y-3">
              {col.links.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link${l.to.replace(/\//g, "-")}`}
                    className="text-sm text-zinc-400 hover:text-[#00C5FE] transition-colors duration-200"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="select-none pointer-events-none" aria-hidden="true">
        <p className="font-heading font-black text-[13.5vw] leading-[0.85] tracking-tighter text-white/[0.05] whitespace-nowrap">
          LINKEXPLN
        </p>
      </div>

      <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p data-testid="footer-copyright" className="font-mono-ls text-[11px] tracking-[0.15em] text-zinc-400">
          © {new Date().getFullYear()} LINKEXPLN AI — ALL RIGHTS RESERVED
        </p>
        <div className="flex gap-6">
          <Link data-testid="footer-bottom-privacy-link" to="/privacy" className="font-mono-ls text-[11px] tracking-[0.15em] text-zinc-400 hover:text-white transition-colors duration-200">
            PRIVACY
          </Link>
          <Link data-testid="footer-bottom-terms-link" to="/terms" className="font-mono-ls text-[11px] tracking-[0.15em] text-zinc-400 hover:text-white transition-colors duration-200">
            TERMS
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
